import {
  IActivableProduct,
  IAppSession,
  ProductType,
  setDxlCampaigns,
} from '@vfit/consumer/data-access';
import { handleEnv, AppMobile } from '@vfit/shared/data-access';

export const APP_SESSION_MOCK: IAppSession = {
  username: 'john.does@vodafone.com',
  firstname: 'COMBINATION',
  email: '',
  fiscalcode: 'XBSBMN80A01F205J',
  status: 'authenticated',
  contactId: '301786062',
  customerId: '57349915',
  installationId: '8e02d6b1d6314c1d86ea3ddcc732d046',
  type_sim: 'ricaricabile',
  osVersion: '13',
  profile: 'A00',
  appVersion: '13.1.0',
  appPlatform: 'Android',
  value: '3444709337',
  type: 'sim',
  sessionId: 'ZAsFe7wZ7ShP3caiS239nzkAtvG7z9Z1',
  mid: '29148987287202002034238077340243094341',
  secretKey: '',
  token:
    '"eyJraWQiOiJ2ZmE6YXV0aG9yaXphdGlvbiIsInR5cCI6IkpXVCIsImFsZyI6IlJTNTEyIn0.eyJhdWQiOm51bGwsInN1YiI6ImUzMD0iLCJzY29wZSI6ImUzMD0iLCJpc3MiOiJhdXRob3JpemF0aW9uIiwiY2xhaW1zIjp7ImFwcENvbnRleHRDbGFpbSI6IntcImF1dGhUeXBlXCI6XCJMT0dJTlwiLFwiaXNOZXh0XCI6dHJ1ZSxcImZpc2NhbENvZGVcIjpcIlhCU05UTTkwQTEyRjIwNVlcIixcInVzZXJuYW1lXCI6XCJuZXh0bWlnMTM1QGdtYWlsLmNvbVwiLFwiY29udGFjdElkXCI6XCIzMDI2MDY5ODFcIixcImN1c3RvbWVySWRcIjpcIjgwMTIxMzYzXCIsXCJqdW5pb3JcIjpmYWxzZSxcIml0ZW1zXCI6W3tcInZhbHVlXCI6XCIzNDUwNTg5ODM2XCIsXCJ0eXBlXCI6XCJtb2JpbGVcIn1dLFwib2xkVG9rZW5cIjpcImV5SmhiR2NpT2lKU1V6STFOaUo5LmV5SnpaWE56YVc5dVgybGtJam9pV25SeVZETkplR2QyTW1kUlQyaERZMVZUY0RKUWRuVnBMWGR2WjNGS1VFVWlMQ0p6ZFdJaU9pSjJiMlJoWm05dVpTMWtlR3dpTENKcGMzTWlPaUpxY3kxc2IyZHBiaUlzSW1GMVpDSTZJbUYxWkdsbGJtTmxYM1poYkhWbElpd2laWGh3SWpveE56STFOakl3TnpFMmZRLlFuT19KV1pmMkpqYkROekpmbldURHJLa0VjOWxSWVlUUG8wUDhXVWd6ak4xXzlTeGFfcU11ZHRjNzdTSl9lNU1zWDBwVUtXSTN2bHAxdjRnM1VLbVN1T2ZTcW9PUW1EQ1NrS3NmU2lSZVAzTjJZTF83czVCaFdWUm9ha2cydk5ZcjJwZzh6dmpubnpIRkppblo5Q25yVkt3cTdSR1FWRTVjU3dkd2pqS0tDNmM2blZZZmZJSTNkSlpMOFRkMmRULXdRbnVzX0JZSHB5RmVZSWVwVjhncXVheG9XY1JxQ0ZUd3pfSHZxMzhwbzdnQ3Fpb1pfeXhnSmdjYXNvSC05bXNTeDl0Sk1CWTVtUkVhQlQ0eVRMNXg1TDIyN09tOVQ0NjVJYW9JbTcwTDdua0ExR2JiaC00MTFKaVlreWNpSE1ucGdvR2Q1S05oVFY4aENrWHZwbEVjQVwiLFwib2xkVG9rZW5TZXNzaW9uSWRcIjpcIlp0clQzSXhndjJnUU9oQ2NVU3AyUHZ1aS13b2dxSlBFXCIsXCJkeGxUb2tlblwiOlwiZXlKcmFXUWlPaUoyWm1FNllYQndMbUYxZEdodmNtbDZZWFJwYjI0aUxDSjBlWEFpT2lKS1YxUWlMQ0poYkdjaU9pSlNVelV4TWlKOS5leUpoZFdRaU9pSmtlR3dpTENKemRXSWlPaUpsZVVwb1pFaFNlV0ZYU2pGa1IxWjZTV3B3TjBsdVZucGFXRXAxV1ZjeGJFbHFiMmxpYlZZMFpFY3hjRnA2UlhwT1ZVSnVZbGRHY0dKRE5XcGlNakJwWmxnd1BTSXNJbk5qYjNCbElqb2laVE13UFNJc0ltbHpjeUk2SW1Gd2NDNWhkWFJvYjNKcGVtRjBhVzl1SWl3aVkyeGhhVzF6SWpwN0luTmxZM1Z5YVhSNVRHVjJaV3dpT2lJeU1DSjlMQ0psZUhBaU9qRTNNalUyTWpBM01UWXNJbk5sWTNKbGRITWlPbTUxYkd4OS5HVkRCM210djNXMVFVWTlmU1hRaG9OampzYldsZU00QUhuMjVjejJOdnhaQ2lZQzJDQTNVa1NYOVhBb2VRODMtOWpwZnlZeTRnbTJ6dGRtcVVKOUFDZF82WUUzQ2NPN0tiMVRwSHRIaVR2TWJqMmlzbUh3d2VCY1d2V3p4cXpmcFByNGVwNHZJQTRsaXJ3b0NsUWZGMnhVS0EweE5Rdk1ZWkR0OHl0eDNFN1AxRUl6Q25GRjJHNVNnS3NNQzNzSEd2RnVrd281UzRkVVBMVXZfdlh3TVFqV3JCS2ZZSW9DM2tYVTRQQWJDSng1aXdIUERaa3ViS3o4eV9yUzVLYi1qZnBJLVV2TERRRG9EUFY1U2hrckZQa2VNaFNBVDhYVHVfVVl0Y1l3OTA5Z0o2X3BjQUpjXzBlOE9Wd1d3QmlnNi15YjhoNGxmdTdteVlDWjRHbURMcW5sbDlCeWdCN2lvSFlkeGo0RDliWTNWWVZZdUVMQV94Ymhnc1NaVDVFcGhFUVlRa3ZlZ1U1b0gxVXJVSzg3Mkc2bElWazlFZ01mVHNuQUY4T01ad0RzR1U5MDYtdEo3TkVvVGs1WklHY2syTDFnWWZfTXc1NmNSX3I3bDJNQjNmaE9NekNLSk00Tk5Ua2VwUVdtWU1aTlRKUVQ1VU9CR0FmakV5eGVrVFE5Y3pQWDdaRlpWc2hVZDlnTS1wMTE4anFjQXBCSzlBNXYxY2RxRlpDWE5xbzc3M0xub25RUWdlNzIzWDYwWjhpTUtaSjZTSENDbkNXLVdWVDZpZGFuRWMxRG9zeXZpckVmblJEY3locjRleUxramI4U1oxQlczV3NrNU5nXzNoc3FhRDBqVkg5U2xZa25PejZDcWVxbEwzMmhfUnBxdWVJMUlSOGZlTmkwQWc4Y1wifSIsInNlY3VyaXR5TGV2ZWwiOiIyMCJ9LCJleHAiOjE3MjU2MjA3MTYsInNlY3JldHMiOm51bGx9.JUOi_IsxjHywjADanSRlagjxjAetJb0ZYeME1Ad4lhfG1Q3--wsDXwoDrLRHwvAYu2NHVmdA7FL8446OYolV5KSbSGmzFBfRsve9JnFl9GHSATetziKNB1vGtlJHGsjbEJ-d3LUtmxRv29mwdoBlaVIBXDGtSNhMYD5tB2nfvP5aRMBIMxjQ5qOIG3qfxusVqM4piZRNbqEKlxdrMLbKhmXcWPU-KRgNLjTMPMLI3fnX983SSnJtJFszQjq2x11tQ51U61hmG5rAjOBVOxS2VsgoZCHQxIONG1Lo2MrJccZhiIxWm79VGNoXTYH1tt7mxl_iJYDC48gdDHizj5598LQCXWYoCMtQrHDfIvqZne97E_TRFYyvkJ_wRXfX0G7deDwLznZoD-agAi2MRjHhLLDb3pAYbewcXbYBts0U9dINUo9XY6dASSqV8lLBNtvqUDMPt0VMNCUusDouCD78Z3TFw8Ukqg1JASVBADsRhpQDQD4o-JMdp2_RGo2YbBnDdHgqdGL1xBQvlCQxX5k5cxuahMirM3Unb8ua2A1IXEj7l2xNrCvdBaLdWt9OpdumccWEP7VaBLMKL7XKdaiOu76j7kl8tAV_OY2m33qPOCMLBgRQbGAQ3fyfC_Z0bboZ3qqJTmBSfv_mq7WjOR8GtV6e9EFUuGUclPOZebIu5Vc"',
  customerUserAgent: 'MyVodafone/android/s/13/13.1.0/2.75/custom/"Google"/"sdk_gphone64_arm64"',
  pbo: 'rt4Gm8uW%2FpQwlGh5%2BSAEWQ%3D%3D',
  isOverlay: true,
  isNext: true,
  role: '',
  items: [
    {
      encryptedValue: 'Eu%2BxK%2BBD7xyo8c43uPBQbQ%3D%3D',
      planType: 'prepaid',
      type: 'sim',
      value: '3339418214',
    },
    {
      encryptedValue: 'Eu%2BxK%2BBD7xyo8c43uPBQbQ%3D%3D',
      planType: 'prepaid',
      type: 'landline',
      value: '081942783',
    },
    {
      encryptedValue: 'Eu%2BxK%2BBD7xyo8c43uPBQbQ%3D%3D',
      planType: 'prepaid',
      type: 'sim',
      value: '3339418217',
    },
  ],
};

export const getDxlAppMock = (): IActivableProduct[] => {
  const dxlIdAppMock = localStorage.getItem('dxlIdAppMock');
  return [
    {
      id: {
        treatmentCode: 'e462.6a6.ffffffff83ed2431.ffffffff8d2f2cd1',
        campaignId: '000001701',
      },
      name: 'Vodafone Club',
      type: 'addon',
      productType: 'NBA' as ProductType,
      description: 'Vantaggi fissi tutti i mesi nelle principali categoria di spesa',
      longDescription:
        'Con Vodafone Club hai vantaggi fissi tutti i mesi nelle principali categorie di spesa per un risparmio minimo di 15€ al mese! Ecco alcuni esempi di sconto: 5€ di buono carburante su 30€ di rifornimento presso i distributori Q8, 10€ di sconto su 99€ di spesa minima presso i supermercati Carrefour, 5% di sconto per le prenotazioni su Booking.com, 30€ di sconto su 150€ di acquisti su Yoox.com. In più ogni mese hai 10 Giga aggiuntivi e il servizio 5G della Rete Vodafone sul tuo numero mobile. Iscriviti a soli 0,99€ il primo mese per godere di tutti i benefici dedicati ai clienti Vodafone Club. Rinnovi successivi a 3,99€ al mese.',
      campaignDetail: {
        bolloDescription: 'Primo mese a 0.99€',
        price: [
          {
            priceRef: 'campaign',
            value: '3.99',
            priceType: 'recurring',
          },
          {
            priceRef: 'campaign',
            value: '0.00',
            priceType: 'oneshot',
          },
          {
            priceRef: 'market',
            value: '3.99',
            priceType: 'recurring',
          },
          {
            priceRef: 'market',
            value: '0.00',
            priceType: 'oneshot',
          },
        ],
        components: {
          retrieveSessionId: '7bcaf301-1d54-4102-bc3f-dfcece378009',
          billingOffer: [
            {
              id: '5472183',
              price: [],
            },
            {
              id: '7418483',
              price: [],
            },
          ],
        },
      },
      activationDate: '2023-03-10',
    },
    {
      id: {
        treatmentCode: 'ea0e.627.ffffffffadb41bd2.ffffffffe82a88ba',
        campaignId: '000001574',
      },
      name: '1 Internet Unlimited Special Edition',
      type: 'fixed change plan',
      productType: 'NBA' as ProductType,
      description:
        'Per te che sei già cliente Vodafone, naviga senza limiti fino a 2.5 Gigabit. Offerta internet casa tutto incluso, compreso il modem e il costo di attivazione di 5€ al mese per 24 mesi',
      longDescription:
        'Per te che sei già cliente Vodafone mobile la fibra non è mai stata così conveniente! Internet illimitato fino ad 2.5 Gigabit al secondo al prezzo scontato di 19,90€ al mese, compreso il modem Vodafone Wi-Fi 6 Station e il costo di attivazione di 5€ al mese per 24 mesi. In più con Giga Family hai 50 Giga extra alla massima velocità della Rete Vodafone sul tuo numero mobile. Puoi inoltre personalizzare la tua offerta con: chiamate verso fissi e mobili nazionali a 3€ in più al mese, Rete Sicura Family a 3.99€ € in più al mese. Lo sconto a 19,90€ al mese è valido solo se mantieni attive sia la tua offerta mobile che quella di rete fissa. Se disattivi la componente mobile pagherai 27,90€ euro al mese.',
      bundlePO: '46399883',
      cmsCategory: 'nba',
      cmsCustomization: {
        activationCost: {
          price: ' ',
          frequency: ' ',
        },
        renewalCost: {
          price: '19,90 €',
          frequency: 'al mese',
        },
        card: {
          shortDescription:
            'La potenza della nostra Rete e Giga in regalo sulla tua SIM mobile ad un prezzo irripetibile.',
          primaryCTA: {
            label: 'Ti chiamiamo gratis',
            actionURL: 'ancora_lockin_card_storytelling',
          },
          defaultCTA: {
            label: 'Scopri di più',
            actionURL: 'ancora_lockin_card_storytelling',
          },
          commercialName: 'Unisci Wi-Fi di casa e mobile',
          hero: {
            type: 'image',
            path: 'https://cdn.mvacloud-dev.vodafone.it/content/dam/myvf/mva10/08_next_catalogo/01_dicembre_22/Card_catalog_MVA12_Lockin_v2.jpg',
          },
        },
        detail: {
          header: {
            shortDescription: 'Naviga a casa, senza limiti.',
            featureList: [
              '19.,90€ al mese',
              'compreso il costo di attivazione di 5€ al mese per 24 mesi',
            ],
          },
          offer: {
            title: 'I vantaggi della Fibra Vodafone',
            description:
              'La comodità è di casa: naviga senza limiti con la migliore tecnologia, tutta la potenza della Rete Vodafone e il Modem con Wi-Fi ottimizzato incluso, per un segnale perfetto per tutti i device collegati.',
            media: {
              type: 'image',
            },
          },
        },
      },
      activationDate: '2023-03-10',
    },
    {
      id: {
        treatmentCode: 'ea0e.627.ffffffffadb41bd2.ffffffffe82a88ba',
        campaignId: '000001574',
      },
      name: '2 Internet Unlimited Special Edition',
      type: 'fixed change plan',
      productType: 'NBA' as ProductType,
      description:
        'Per te che sei già cliente Vodafone, naviga senza limiti fino a 2.5 Gigabit. Offerta internet casa tutto incluso, compreso il modem e il costo di attivazione di 5€ al mese per 24 mesi',
      longDescription:
        'Per te che sei già cliente Vodafone mobile la fibra non è mai stata così conveniente! Internet illimitato fino ad 2.5 Gigabit al secondo al prezzo scontato di 19,90€ al mese, compreso il modem Vodafone Wi-Fi 6 Station e il costo di attivazione di 5€ al mese per 24 mesi. In più con Giga Family hai 50 Giga extra alla massima velocità della Rete Vodafone sul tuo numero mobile. Puoi inoltre personalizzare la tua offerta con: chiamate verso fissi e mobili nazionali a 3€ in più al mese, Rete Sicura Family a 3.99€ € in più al mese. Lo sconto a 19,90€ al mese è valido solo se mantieni attive sia la tua offerta mobile che quella di rete fissa. Se disattivi la componente mobile pagherai 27,90€ euro al mese.',
      bundlePO: '36399883',
      cmsCategory: 'nba',
      cmsCustomization: {
        activationCost: {
          price: ' ',
          frequency: ' ',
        },
        renewalCost: {
          price: '19,90 €',
          frequency: 'al mese',
        },
        card: {
          shortDescription:
            'La potenza della nostra Rete e Giga in regalo sulla tua SIM mobile ad un prezzo irripetibile.',
          primaryCTA: {
            label: 'Ti chiamiamo gratis',
            actionURL: 'ancora_lockin_card_storytelling',
          },
          defaultCTA: {
            label: 'Scopri di più',
            actionURL: 'ancora_lockin_card_storytelling',
          },
          commercialName: 'Unisci Wi-Fi di casa e mobile',
          hero: {
            type: 'image',
            path: 'https://cdn.mvacloud-dev.vodafone.it/content/dam/myvf/mva10/08_next_catalogo/01_dicembre_22/Card_catalog_MVA12_Lockin_v2.jpg',
          },
        },
        detail: {
          header: {
            shortDescription: 'Naviga a casa, senza limiti.',
            featureList: [
              '19.,90€ al mese',
              'compreso il costo di attivazione di 5€ al mese per 24 mesi',
            ],
          },
          offer: {
            title: 'I vantaggi della Fibra Vodafone',
            description:
              'La comodità è di casa: naviga senza limiti con la migliore tecnologia, tutta la potenza della Rete Vodafone e il Modem con Wi-Fi ottimizzato incluso, per un segnale perfetto per tutti i device collegati.',
            media: {
              type: 'image',
            },
          },
        },
      },
      activationDate: '2023-03-10',
    },
    {
      id: {
        treatmentCode: 'ea0e.627.ffffffffadb41bd2.ffffffffe82a88ba',
        campaignId: '000001574',
      },
      name: 'Internet Unlimited Special Edition',
      type: 'fixed change plan',
      productType: 'NBA' as ProductType,
      description:
        'Per te che sei già cliente Vodafone, naviga senza limiti fino a 2.5 Gigabit. Offerta internet casa tutto incluso, compreso il modem e il costo di attivazione di 5€ al mese per 24 mesi',
      longDescription:
        'Per te che sei già cliente Vodafone mobile la fibra non è mai stata così conveniente! Internet illimitato fino ad 2.5 Gigabit al secondo al prezzo scontato di 19,90€ al mese, compreso il modem Vodafone Wi-Fi 6 Station e il costo di attivazione di 5€ al mese per 24 mesi. In più con Giga Family hai 50 Giga extra alla massima velocità della Rete Vodafone sul tuo numero mobile. Puoi inoltre personalizzare la tua offerta con: chiamate verso fissi e mobili nazionali a 3€ in più al mese, Rete Sicura Family a 3.99€ € in più al mese. Lo sconto a 19,90€ al mese è valido solo se mantieni attive sia la tua offerta mobile che quella di rete fissa. Se disattivi la componente mobile pagherai 27,90€ euro al mese.',
      bundlePO: dxlIdAppMock || '6399883',
      cmsCategory: 'nba',
      cmsCustomization: {
        activationCost: {
          price: ' ',
          frequency: ' ',
        },
        renewalCost: {
          price: '19,90 €',
          frequency: 'al mese',
        },
        card: {
          shortDescription:
            'La potenza della nostra Rete e Giga in regalo sulla tua SIM mobile ad un prezzo irripetibile.',
          primaryCTA: {
            label: 'Ti chiamiamo gratis',
            actionURL: 'ancora_lockin_card_storytelling',
          },
          defaultCTA: {
            label: 'Scopri di più',
            actionURL: 'ancora_lockin_card_storytelling',
          },
          commercialName: 'Unisci Wi-Fi di casa e mobile',
          hero: {
            type: 'image',
            path: 'https://cdn.mvacloud-dev.vodafone.it/content/dam/myvf/mva10/08_next_catalogo/01_dicembre_22/Card_catalog_MVA12_Lockin_v2.jpg',
          },
        },
        detail: {
          header: {
            shortDescription: 'Naviga a casa, senza limiti.',
            featureList: [
              '19.,90€ al mese',
              'compreso il costo di attivazione di 5€ al mese per 24 mesi',
            ],
          },
          offer: {
            title: 'I vantaggi della Fibra Vodafone',
            description:
              'La comodità è di casa: naviga senza limiti con la migliore tecnologia, tutta la potenza della Rete Vodafone e il Modem con Wi-Fi ottimizzato incluso, per un segnale perfetto per tutti i device collegati.',
            media: {
              type: 'image',
            },
          },
        },
      },
      activationDate: '2023-03-10',
    },
    {
      id: {
        treatmentCode: 'dbd4.6a4.ffffffffe7fb19ea.61bc22fa',
        campaignId: '000001699',
      },
      name: 'Rete Sicura 2.0',
      type: 'addon',
      productType: 'NBA' as ProductType,
      description:
        'Per proteggere i tuoi dati personali e la navigazione internet del tuo dispositivo',
      longDescription:
        'Attiva Rete Sicura 2.0, servizio che protegge i tuoi dati personali (nomi utente, password, carte di credito, indirizzo mail) e la navigazione internet del tuo dispositivo. Con il Parental Control puoi filtrare i siti con contenuti inappropriati per i tuoi figli. Il servizio ID monitoring di Iris powered by Generali verifica la presenza dei tuoi dati su dark e deep Web, ti fornisce un riscontro immediato e ti aiuta a gestire eventuali danni. Inoltre, con il nuovo portale Coach digitale ricevi notizie, consigli e podcast per conoscere i rischi della rete e per imparare a difenderti meglio. Scopri il nuovo mondo della sicurezza per te e la tua famiglia a soli 0.99€ il primo mese, i rinnovi successivi a 1.99€ al mese.',
      campaignDetail: {
        bolloDescription: 'Primo mese a 0.99€',
        price: [
          {
            priceRef: 'campaign',
            value: '1.99',
            priceType: 'recurring',
          },
          {
            priceRef: 'campaign',
            value: '0.00',
            priceType: 'oneshot',
          },
          {
            priceRef: 'market',
            value: '1.99',
            priceType: 'recurring',
          },
          {
            priceRef: 'market',
            value: '0.00',
            priceType: 'oneshot',
          },
        ],
        components: {
          retrieveSessionId: '7bcaf301-1d54-4102-bc3f-dfcece378009',
          billingOffer: [
            {
              id: '259530095',
              price: [],
            },
            {
              id: '7418583',
              price: [],
            },
          ],
        },
      },
      activationDate: '2023-03-10',
    },
  ];
};

const bwjExecuteSetupViewConfiguration = () => {
  const is = (type: any, val: any) => ![undefined, null].includes(val) && val.constructor === type;
  const serialize = (params: any) =>
    Object.keys(params)
      .map((key: any) => {
        let item = params[key];

        if (is(Array, item) || is(Object, item)) {
          item = JSON.stringify(item);
        }
        return `${key}=${encodeURIComponent(item)}`;
      })
      .join('&');
  const param = { parameters: { hideTOBi: true, fullNoHeader: true } };
  window.BWB_JS?.execute('setupViewConfiguration', serialize(param), null);
};

const isAppMock = (): boolean => {
  const nodeEnv = handleEnv('NODE_ENV') || '';
  const mockApp = handleEnv('NEXT_PUBLIC_MOCK_APP') || '';
  if (mockApp) {
    return mockApp?.toString()?.toLowerCase() === 'true';
  }
  return (nodeEnv && nodeEnv === 'LOCAL') || (nodeEnv && nodeEnv === 'development');
};

const retrieveAppSession = () => {
  if (!AppMobile.checkIsApp()) return;
  bwjExecuteSetupViewConfiguration();
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.setSessionCb = (appSessionValue: IAppSession) => {
    if (appSessionValue) {
      window.localStorage.setItem('appSession', JSON.stringify(appSessionValue));
      window.sessionStorage.setItem('dxlJwt', appSessionValue?.token || '');
    }
  };
  window.BWB_JS?.execute('getSession', '', 'setSessionCb');
  localStorage.setItem('isApp', 'true');
  const cfAppMock = localStorage.getItem('cfAppMock');
  if (isAppMock()) {
    window.localStorage.setItem(
      'appSession',
      JSON.stringify({
        ...APP_SESSION_MOCK,
        fiscalcode: cfAppMock || APP_SESSION_MOCK.fiscalcode,
      })
    );
    window.sessionStorage.setItem('dxlJwt', APP_SESSION_MOCK?.token || '');
    setDxlCampaigns(getDxlAppMock());
  }
};

export { isAppMock, retrieveAppSession };
